import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import Header from "./header/Header";
import Body from "./body/Body";
import TimeOverPopup from "./popup/TimeOverPopup";
import NotEnteredAnswerPopup from "./popup/NotEnteredAnswerPopup";
import ConceptCheckPlayer from "../../../common/ConceptCheckPlayer";
import ConceptCheckPlayerBox from "../../../common/iframe/ConceptCheckPlayerBox";

const AnsweringQuestions = ( props ) => {

  const answeringQuestions = useSelector( state => state.answeringQuestions );

  const {
    Logger,
    TimeOverPopupHider,
    NotEnteredAnswerChecker,
    ConceptCheckPlayerHider,
    children,
    ...PROPS
  } = props;

  return (
    <Logger>
      <ConceptCheckPlayerBox />
      <div className="layout-def layout-learning gm">
        <Header { ...PROPS } />
        <Body { ...PROPS } />
        { answeringQuestions.isShowTimeOverPopup && <TimeOverPopupHider><TimeOverPopup /></TimeOverPopupHider> }
        { answeringQuestions.isShowNotEnteredAnswerPopup && <NotEnteredAnswerChecker><NotEnteredAnswerPopup /></NotEnteredAnswerChecker> }
        { answeringQuestions.isShowConceptCheckPlayer && <ConceptCheckPlayerHider><ConceptCheckPlayer /></ConceptCheckPlayerHider> }
      </div>
    </Logger>
  );

};

AnsweringQuestions.defaultProps = {
  Logger : Fragment,
  TimeOverPopupHider : Fragment,
  NotEnteredAnswerChecker : Fragment,
  ConceptCheckPlayerHider : Fragment
};

export default AnsweringQuestions;
